import { IDataAccessor, AbstractAccessorService } from "@core/data-access";
import { IResponse } from "@core/data-access/model";
import { IPropertyFormRestService } from "./property-form-rest";
import { PropertyFormUrlParams } from "./model/domain/property-form-url-params";

export class PropertyFormRestService extends AbstractAccessorService<string> implements IPropertyFormRestService {

    public readonly $name: string = "PropertyFormRestService";

    public static readonly $inject: string[] = ["$accessor"];

    constructor(public $accessor: IDataAccessor<any>) {
        super();
    }

    getUrl(parameter:PropertyFormUrlParams): angular.IPromise<IResponse<string>> {
        return this.$accessor<string, string, PropertyFormUrlParams,'getUrl'>(this.$name, "getUrl", {
            parameter: parameter
        })
    }
}

